const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://ed8ig1wy0e.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://s7676xyfwc.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://w78fyuwtl1.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'hotfix/CV4-3158-cascade-parent-status',
    HOSTNAME: 'https://locations.dev.platform.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.dev.platform.forwoodsafety.com',
    WEBSOCKET: 'wss://ff1aofwdkd.execute-api.us-west-2.amazonaws.com/dev'
  },
};

export default config;